import { apiGetAccount } from '../../common/api/profile'
import { apiDeleteWork, apiUpdateWork } from '../../common/api/works'

export const fetchWorks = (pupilId, params = {}) => ({
  requestPrefix: 'WORKS_STORE:FETCH',
  params: { pupilId, ...params },
  request: () =>
    apiGetAccount(pupilId, {
      include: `account.student_type.works,account.student_type.work.names,account.student_type.work.status,account.student_type.work.timestamps,account.student_type.work.year_group,account.student_type.work.year_group.names,account.student_type.work.year_group.order,account.student_type.works.limit.20,account.student_type.works.order.desc,account.student_type.works.page.${params.page ||
        1},account.student_type.work.media,account.student_type.work.medium.thumb,account.student_type.work.independent`
    })
})

export const deleteWork = id => ({
  requestPrefix: 'WORKS_STORE:DELETE',
  params: { id },
  request: () => apiDeleteWork(id)
})

export const updateWork = (id, data) => ({
  requestPrefix: 'WORKS_STORE:UPDATE',
  params: { id, data },
  request: () => apiUpdateWork(id, data)
})
